
import utils from './Utils';

export default {
    /**
     *  调用后台webapi
     * @param {Object} params 参数信息
     * {
     *  apiCode         :   api编号，
     *  componentCode   :   构件编号,
     *  params          ：  参数信息，
     *  success         :   成功回调，
     *  fail            :   失败回调
     * }
     */
    exec : function(params){
        if(!utils.assertNotNull(params,'apiCode')||!utils.assertNotNull(params,'componentCode')){
            let msg = '调用后台webapi时，请传递apiCode、componentCode参数！';
            if(params.fail){
                params.fail({
                    type : "UnExpectedException",
                    msg : msg
                });
            }else{
                throw Error(msg);
            }
        }
        let promise = utils.loadVjs("vjs.framework.extension.platform.services.operation.remote.ruleset");
        promise.then(sb=>{
            let invoker = sb.getService("vjs.framework.extension.platform.services.operation.remote.RemoteMethodAccessor");
            invoker.invokeV3Webapi({
                componentCode : params.componentCode,
                apiCode : params.apiCode,
                param : params.params,
                afterResponse : params.success,
                error : params.fail
            });
        }).catch(err=>{
            params.fail&&params.fail(err);
        });
    }
};


// WEBPACK FOOTER //
// ./src/Webapi.js